import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { useTranslate } from "react-admin";

import { CrmObject, type CustomerServiceCrmRecordQuery } from "../../generated/graphql";
import { CRM_OBJECT_COLORS, formatCrmCount, formatCrmDate } from "../../lib/crm";
import { InventoryTable } from "../logistics/InventoryTable";
import { CrmCard } from "./CrmCard";
import { CrmIconTile } from "./CrmObjectIcon";

type History = NonNullable<CustomerServiceCrmRecordQuery["customerServiceCrmRecord"]>["contractItemInventoryHistory"];
const DATE_FIELDS = ["atClientDate", "removedFromClientDate", "inStockDate"] as const;

export const ContractItemInventoryHistory = ({ history }: { history: History }) => {
  const translate = useTranslate();
  const title = translate("crm.contractItem.inventoryHistory");
  return (
    <CrmCard
      flush
      testId="crm-contract-item-inventory-history"
      title={`${title} (${formatCrmCount(history.length)})`}
      icon={<CrmIconTile Icon={Inventory2OutlinedIcon} color={CRM_OBJECT_COLORS[CrmObject.Order]} size={24} />}
    >
      <InventoryTable
        label={title}
        empty={translate("crm.related.empty")}
        columns={DATE_FIELDS.map(key => ({ key, label: translate(`crm.contractItem.${key}`) }))}
        rows={history.map(entry => ({
          key: entry.id,
          inventory: entry.inventory,
          deletedInSalesforceAt: entry.deletedInSalesforceAt,
          cells: DATE_FIELDS.map(key => entry[key] && formatCrmDate(entry[key])),
        }))}
      />
    </CrmCard>
  );
};
